module.exports = __webpack_public_path__ + "static/media/4.b1c131b8.jpg";